/** @jsxImportSource @emotion/react */
// import { ReactComponent as AffiliateSVG } from "assets/Common/icons/affiliate.svg";
// import { ReactComponent as AffiliateActiveSvg } from "assets/Common/icons/affiliateActive.svg";
import { ReactComponent as HomeSVG } from "assets/Common/icons/home.svg";
import { ReactComponent as HomeActiveSvg } from "assets/Common/icons/homeActive.svg";
// import { ReactComponent as MessageSVG } from "assets/Common/icons/message.svg";
// import { ReactComponent as MessageActiveSVG } from "assets/Common/icons/messageActive.svg";
import { ReactComponent as ProfileSvg } from "assets/Common/icons/profile.svg";
import { ReactComponent as ProfileActiveSvg } from "assets/Common/icons/profileActive.svg";
import { ReactComponent as PromosActiveSvg } from "assets/Common/icons/promoActive.svg";
import { ReactComponent as PromosSvg } from "assets/Common/icons/promos.svg";
import Deposit_Green from "assets/Mobile/icons/deposit.png";
import { ReactComponent as MenuIcon } from "assets/Mobile/icons/menuIcon.svg";
import { ReactComponent as HistoryIcon } from "assets/temporary/icons/history.svg";
import { PATH } from "contants/path";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { selectIsAuthenticated } from "store/auth";
import { selectIsCreditAgentLine } from "store/feature";
import { setOpenModal } from "store/modal";
import { theme } from "styles/theme";

import { BottomTabsStyle } from "./index.style";
const arrayTabs = [
  // {
  //   label: "Home",
  //   link: PATH.Home,
  //   icon: (color: string) => (
  //     <img className="item-tab-home" src={HomeIcon} alt="" />
  //   ),
  //   iconActive: () => <img className="item-tab-home" src={HomeIcon} alt="" />,
  //   classNameIcon: "icon-tab-home",
  //   className: "item-tab-home",
  // },
  // {
  //   label: "Contact Us",
  //   link: PATH.contactUs,
  //   icon: () => <ContactUsSVG />,
  //   iconActive: () => <ContactUsActiveSVG />,
  //   className: "item-tab-sponsor",
  // },

  // {
  //   label: "Brand",
  //   link: PATH.Brand,
  //   icon: (color: string) => <BrandSVG fill={color} />,
  //   iconActive: () => <BrandActiveSVG />,
  // },

  {
    label: "Home",
    link: PATH.Home,
    icon: (color: string) => <HomeSVG fill={color} />,
    iconActive: (color: string) => <HomeActiveSvg color={color} />,
  },
  {
    label: "Promotion",
    link: PATH.Promotion,
    icon: (color: string) => <PromosSvg fill={color} />,
    iconActive: (color: string) => <PromosActiveSvg color={color} />,
  },
  {
    label: "History",
    link: PATH.User.TransactionHistory,
    icon: (color: string) => <HistoryIcon stroke={color} />,
    iconActive: (color: string) => <HistoryIcon stroke={color} />,
  },
  {
    label: "Deposit",
    link: PATH.Deposit,
    icon: (color: string) => (
      <img className="icon-deposit" src={Deposit_Green} alt="" />
    ),
    iconActive: () => (
      <img className="icon-deposit" src={Deposit_Green} alt="" />
    ),
    classNameIcon: "icon-tab-home",
    className: "item-tab-home",
  },

  // {
  //   label: "Affiliate",
  //   link: PATH.User.Referral,
  //   icon: (color: string) => <AffiliateSVG fill={color} />,
  //   iconActive: () => <AffiliateActiveSvg />,
  // },
  // {
  //   label: "Messages",
  //   link: PATH.User.Announcement,
  //   icon: () => <MessageSVG />,
  //   iconActive: (color: string) => <MessageActiveSVG color={color} />,
  // },
  {
    label: "Profile",
    link: PATH.User.profile,
    icon: (color: string) => <ProfileSvg fill={color} />,
    iconActive: (color: string) => <ProfileActiveSvg color={color} />,
    isActive: (pathname: string) => pathname === PATH.User.profile,
  },
  {
    label: "More",
    link: PATH.User.More,
    icon: (color: string) => <MenuIcon fill={color} />,
    iconActive: (color: string) => <MenuIcon fill={color} />,
    isActive: (pathname: string) =>
      pathname === PATH.User.Announcement ||
      pathname.startsWith(PATH.User.More),
  },
];
const BottomTabs = () => {
  const { pathname } = useLocation();

  const dispatch = useAppDispatch();

  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  // const toggleFeature = useAppSelector(selectDataFeature);
  const isCreditAgentLine = useAppSelector(selectIsCreditAgentLine);

  const { t } = useTranslation(["bottomtab"]);
  return (
    <div css={BottomTabsStyle.container}>
      <div css={BottomTabsStyle.lisTabs}>
        {arrayTabs.map((item, index) => {
          const isActive = item.isActive
            ? item.isActive(pathname)
            : pathname === item.link;

          const checkIsAuthenticated =
            isAuthenticated ||
            item.link !== PATH.Home ||
            item.link !== PATH.Promotion;

          // loại bỏ promos nếu toggleFeature bật
          if (item.label === "Promotion" && isCreditAgentLine) return null;
          // Thêm icon history nếu ko có pronotion menu
          if (item.label === "History" && !isCreditAgentLine) return null;
          // loại bỏ deposit nếu toggleFeature bật
          if (item.label === "Deposit" && isCreditAgentLine) return null;

          return (
            <div
              css={BottomTabsStyle.itemTab}
              key={`item-bottom-tab-${index}`}
              style={item.label === "More" ? { padding: "4px 0" } : {}}
            >
              <Link
                className={item.className}
                css={BottomTabsStyle.itemLink}
                to={item.link}
                onClick={(e) => {
                  if (checkIsAuthenticated) return;
                  e.preventDefault();
                  dispatch(setOpenModal("signin"));
                }}
              >
                <div
                  className={item.classNameIcon}
                  css={BottomTabsStyle.itemIcon}
                >
                  {isActive
                    ? item.iconActive(theme.colors.darkGreen)
                    : item.icon(theme.colors.gray[100])}
                  <span
                    css={BottomTabsStyle.itemLabel(
                      isActive ? theme.colors.darkGreen : theme.colors.gray[100]
                    )}
                  >
                    {t(item.label)}
                  </span>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BottomTabs;
